import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { UsersService, PaginationService } from "../../service";
import { Client, Fine, PortalOperator } from "../../entity";

@Component({
    selector: 'user-fines-cmp',
    templateUrl: './user-fines.component.html'
})

export class UserFinesComponent implements OnInit {
    user: Client = new Client();
    fines: Array<Fine> = new Array<Fine>();
    loadingState: boolean = false;
    noRecordsState: boolean = false;
    tagsFilter = {
        Location: new Array<string>(),
    }
    vehiclePlateFilter: Fine = { Plate: '' };

    //#region pagination properties
    pagedItems: Array<Fine>;
    pager: any = {};
    //#endregion

    constructor(
        private route: ActivatedRoute,
        private userService: UsersService,
        private paginationService: PaginationService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        this.route.queryParams.subscribe((params: Params) => {
            this.user.FullName = params['name'];
            this.user.PortalOperatorID = params['id'];
        });

        this.getFines();
    }

    getFines() {
        this.loadingState = true;

        this.userService.getUserFines(this.user.PortalOperatorID).subscribe(data => {
            var fines = new Array<Fine>();
            data.forEach(item => {
                var fine = new Fine();
                fine.fromObject(item);

                if (fine.Avatar == null) {
                    fine.Avatar = './../../assets/placeholder.jpg'
                }
                fine.Location = fine.Location.split(', ')[1];

                fines.push(fine);
            });

            this.fines = fines;
            this.loadingState = false;
            this.setPage(1);

            if (this.fines.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });
    }

    updateFilterTags(tags: Array<string>) {
        this.tagsFilter.Location = tags;
    }

    //#region pagination methods
    setPage(page: number): void {
        this.pager = this.paginationService.getPager(this.fines.length, page, 6);
        this.pagedItems = this.fines.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    //#endregion
}